import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { User } from '@/models/User';

interface IWorkspaceAdminInfo {
  id: string;
  title: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'UserDeleteConfirmDialog',
  props: {
    soleAdminWorkspaces: null
  },
  setup(__props: any, { expose, emit }: { emit: ({
  confirmed: [data: { transferToUserId?: string; deleteAll: boolean }];
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  soleAdminWorkspaces: IWorkspaceAdminInfo[];
}





const showDialog = ref(false);
const transferOption = ref('transfer');
const selectedRecipientId = ref('');
const availableUsers = ref<User[]>([]);
const sharedArticlesCount = ref(0);

const isFormValid = computed(() => {
  if (props.soleAdminWorkspaces.length) return false;
  if (sharedArticlesCount.value === 0) {
    return true;
  }
  if (transferOption.value === 'transfer') {
    return selectedRecipientId.value !== '';
  }
  return true;
});

const show = async (users: User[], articlesCount: number) => {
  availableUsers.value = users;
  sharedArticlesCount.value = articlesCount;
  transferOption.value = 'transfer';
  selectedRecipientId.value = '';
  showDialog.value = true;
};

const handleCancel = () => {
  showDialog.value = false;
};

const handleConfirm = () => {
  emit('confirmed', {
    transferToUserId:
      transferOption.value === 'transfer' && sharedArticlesCount.value > 0 ? selectedRecipientId.value : undefined,
    deleteAll: transferOption.value === 'delete',
  });
  showDialog.value = false;
};

const getRecipientName = () => {
  const recipient = availableUsers.value.find((u) => u.id === selectedRecipientId.value);
  return recipient ? `${recipient.firstName} ${recipient.lastName}` : '';
};

expose({ show });

return { __sfc: true,props, emit, showDialog, transferOption, selectedRecipientId, availableUsers, sharedArticlesCount, isFormValid, show, handleCancel, handleConfirm, getRecipientName }
}

})